import type { ContractFieldDefinition, ContractTableValues, ContractTemplate } from '~/types/models';

export function contractTemplateValues(fields: ContractFieldDefinition[]): Record<string, string> {
    return Object.fromEntries(fields
        .filter(field => field.type !== 'proposal' && Boolean(field.defaultValue))
        .map(field => [field.key, field.defaultValue || '']));
}

type ContractTemplateEntries = {
    values: Record<string, string>;
    proposalReferences: Record<string, string>;
    proposalReferenceLinks: Record<string, string>;
    tableValues: ContractTableValues;
};

/** Refresh template structure while retaining entries belonging to the draft. */
export function contractTemplateDraft(template: ContractTemplate, current?: ContractTemplateEntries) {
    const fields = template.fields.map(field => ({ ...field }));
    const tables = (template.tables || []).map(table => ({ ...table, columns: table.columns.map(column => ({ ...column })) }));
    const proposalKeys = new Set(fields.filter(field => field.type === 'proposal').map(field => field.key));
    const proposalEntries = (entries: Record<string, string> = {}) => Object.fromEntries(Object.entries(entries).filter(([key]) => proposalKeys.has(key)));
    return {
        documentHtml: template.contentHtml,
        fields,
        tables,
        values: { ...contractTemplateValues(fields), ...current?.values },
        proposalReferences: proposalEntries(current?.proposalReferences),
        proposalReferenceLinks: proposalEntries(current?.proposalReferenceLinks),
        tableValues: Object.fromEntries(tables.flatMap(table => {
            const rows = current?.tableValues[table.key];
            return rows ? [[table.key, rows.map(row => Object.fromEntries(table.columns.map(column => [column.key, row[column.key] ?? ''])))]] : [];
        })) as ContractTableValues,
    };
}
